import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button';
import Label from 'components/form/Label/Label';
import { SmallModal } from 'components/Modals/SmallModal';
import React from 'react';

const InactiveCardWarningModal = props => {
  return (
    <SmallModal
      visible={props.inactiveCardWarningModalOpen}
      onCancel={props.toggleInactiveCardWarningModal}
      footer={
        <FlexContainer className="mobileCol-desktopRow justify-end">
          <Button
            mrphType="standard"
            datatestid="cancel-inactive-card-modal"
            onClick={props.toggleInactiveCardWarningModal}
            className="m-margB8"
          >
            Cancel
          </Button>
          <Button
            mrphType="primary"
            datatestid="chat-inactive-card-modal"
            onClick={props.onClickChat}
          >
            Chat Support
          </Button>
        </FlexContainer>
      }
    >
      <Label type="H1" typeHeader={'h1'}>
        Inactive Card
      </Label>
      <Label type="Body-1">
        Your card is inactive right now. Please contact our Support team to
        assist you.
      </Label>
    </SmallModal>
  );
};

export default InactiveCardWarningModal;
